import { Col, Form, Input, notification, Select } from "antd";
import api from "../../services/api";
import { useStateValue } from "../../state";
import { useEffect, useState } from "react";
import { listagemActions, manutencaoActions } from "../../actions";
import { FormGW } from "../../components";

export default function ManutencaoTipoEquipamento({ formulario, carregando, aoSalvar, editando }) {

    const [{ ui, manutencao }, dispatch] = useStateValue();
    const [loading, setLoading] = useState(false);
    const [hover, setHover] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [listaIdentificacao, setIdentificacao] = useState([]);

    useEffect(() => {
        api.get(`Enum/Listar?nome=OsTipoIdentificacao`).then(res => {
            if (res.status === 200) {
                setIdentificacao(res.data);
            }
        }).catch((erro) => console.error(erro));

    }, []);

    const salvarManutencao = (values) => {
        carregando(true);
        let retorno;

        let enderecoUrl = 'TipoEquipamento/';

        if (values.teq_id) {
            enderecoUrl += `Editar`;
            api.put(enderecoUrl, values).then(res => {
                if (res.status === 200) {
                    notification.success({ message: 'Operação concluída', description: "As novas configurações foram salvas com sucesso!" });
                    retorno = res.data;
                }
            }, err => {
                notification.error({ message: 'Erro ao processar a requisição.', description: JSON.stringify(err.response) });
            }).finally(
                () => {
                    atualizarPagina();
                    carregando(false);
                    aoSalvar(retorno);
                })
        } else {
            enderecoUrl += `Incluir`;
            api.post(enderecoUrl, values).then(res => {
                if (res.status === 200) {
                    notification.success({ message: 'Operação concluída', description: "As configurações foram incluidas com sucesso!" });
                    retorno = res.data;
                    dispatch({ type: manutencaoActions.CHANGE, data: { dados: res.data } });
                }
            }, err => {
                notification.error({ message: 'Erro ao processar a requisição.', description: JSON.stringify(err.response) });
            }).finally(
                () => {
                    atualizarPagina();
                    carregando(false);
                    aoSalvar(retorno);
                }
            );
        }
    }

    function atualizarPagina() {
        dispatch({ type: listagemActions.CHANGE, data: { ordem: '+teq_descricao' } });
    };

    return (
        <FormGW layout="vertical" form={formulario} name="ManutencaoTipoEquipamento" onFinish={salvarManutencao}>

            <Form.Item name="teq_id" hidden> <Input />
            </Form.Item>

            <Col xs={24} sm={24} md={13} lg={13} xl={13}>
                <Form.Item label="Descrição" name="teq_descricao" rules={[{ required: true, message: 'Informe a Descrição do Tipo de Equipamento' },]}>
                    <Input.TextArea
                        autoSize={{
                            minRows: 2,
                            maxRows: 6,
                        }}
                        maxLength={50}
                        placeholder="Relatos do problema conforme descrito pelo cliente" />
                </Form.Item>
            </Col>
            <Col xs={5} sm={5} md={5} lg={5} xl={5}>
                <Form.Item  label="Tipo de Identificação do Equipamento"  name="teq_exigeidentificacao" rules={[{ required: true }]}>
                    <Select showSearch optionFilterProp="children" placeholder="Selecione o Tipo de Identificação do Equipamento"
                    filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0} >
                    {listaIdentificacao?.map(item => (
                            <Select.Option key={item.key} value={item.key}> {`${item.key} - ${item.value}`}  
                        </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Col>

        </FormGW >
    );

}